<template>
  <div class="break section-block row-box">
    <WrapperField
      v-for="(value, index) in assigneeData"
      :key="value + index + Math.random()"
      :data="
        createDataField({
          fieldName: index,
          fieldValue: value,
          fieldGroup: FieldGroup.ASSIGNEE,
        })
      "
    ></WrapperField>
    <Block
      v-if="identityDocument"
      :data="identityDocument"
      :field-group="FieldGroup.IDENTITY_DOCUMENT_SHORT"
    />

    <!-- Реквизиты документа, подтверждающего должность или статус представителя -->
    <template
      v-if="data.documents && data.documents.statusDocument && !documentsHidden"
    >
      <TitleField
        v-if="data.documents.statusDocument"
        fieldName="isStatusDocument"
        :fieldGroup="FieldGroup.DOCUMENT"
      />
      <WrapperField
        v-for="(value, index) in data.documents.statusDocument"
        :key="value + index + Math.random()"
        :data="
          createDataField({
            fieldName: index,
            fieldValue: value,
            fieldGroup: FieldGroup.DOCUMENT,
          })
        "
      ></WrapperField>
    </template>

    <!-- Реквизиты документа, подтверждающего полномочия представителя -->
    <template
      v-if="
        data.documents && data.documents.authorityDocument && !documentsHidden
      "
    >
      <TitleField
        fieldName="isAuthorityDocument"
        :fieldGroup="FieldGroup.DOCUMENT"
      />
      <WrapperField
        v-for="(value, index) in data.documents.authorityDocument"
        :key="value + index + Math.random()"
        :data="
          createDataField({
            fieldName: index,
            fieldValue: value,
            fieldGroup: FieldGroup.DOCUMENT,
          })
        "
      ></WrapperField>
    </template>
  </div>
</template>

<script>
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';
import Block from '@/components/elements/statement/FullStatementView/elements/Block';
import cloneDeep from 'clone-deep';

export default {
  name: 'Assignee',
  components: {
    Block,
    WrapperField,
    TitleField,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    documentsHidden: {
      type: Boolean,
    },
  },
  data: () => ({
    createDataField,
    FieldGroup,
  }),
  computed: {
    identityDocument() {
      return this.data?.documents?.identityDocument;
    },

    assigneeData() {
      if (this.documentsHidden) {
        const data = cloneDeep(this.data);

        delete data.status;

        return data;
      }

      return this.data;
    },
  },
};
</script>
